<template>
  <div>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
          @submit.native.prevent
        >
          <el-form-item label="关键字" prop="number">
            <el-input
              size="small"
              v-model="filter.query"
              placeholder="设备描述、件号、序列号"
              autocomplete="off"
              @keyup.enter.native="requestDeviceList()"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="状态"
            prop="number"
            v-if="auth.isPlatformUser() && this.status <= 0"
          >
            <el-select
              v-model="filter.status"
              size="small"
              placeholder="请选择"
              style="width: 100%"
              :clearable="true"
            >
              <el-option
                v-for="(value, key) in UsedDeviceStatusMap"
                :key="key"
                v-if="parseInt(key) != Math.abs(status)"
                :label="value.name"
                :value="parseInt(key)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestDeviceList()"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header flex-row-between">
        <el-button
          v-if="status <= 0"
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="startUsedDevice"
          v-permission="Auth.usedDeviceCreate"
          >新设备</el-button
        >
        <span></span>
        <file-button
          v-permission="Auth.usedDeviceIE"
          style="float: right"
          obj="used_device"
          :filter="realFilter"
          class="mobile-hide"
          @importCallback="importCallback"
        ></file-button>
      </div>
      <el-table v-if="!isMobile()" :data="devices" v-loading="loading">
        <el-table-column label="设备描述" prop="material_desc">
          <template slot-scope="scope">
            <div>
              {{ scope.row.material_desc }}
              <i
                class="el-icon-picture"
                v-if="scope.row.pics && scope.row.pics.length > 0"
              ></i>
            </div>
            <div v-if="scope.row.remark.length > 0" class="font-12 text-danger">
              <i class="el-icon-warning"></i> {{ scope.row.remark }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="件号"
          prop="material"
          width="120px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="序列号"
          prop="serial_number"
          width="120px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="数量"
          align="center"
          prop="quantity"
          width="50px"
        >
        </el-table-column>
        <el-table-column
          label="单价/元"
          align="center"
          prop="price"
          width="120px"
        >
        </el-table-column>
        <el-table-column
          label="生产日期"
          prop="product_date"
          width="120px"
          align="center"
        >
        </el-table-column>
        <el-table-column label="发布日期" width="120px" align="center">
          <template slot-scope="scope">
            <span>
              {{ formatTime(scope.row.created_at) }}
            </span>
          </template></el-table-column
        >
        <el-table-column
          label="状态"
          width="80px"
          align="center"
          v-if="auth.isPlatformUser()"
        >
          <template slot-scope="scope">
            <status-tag
              :name="UsedDeviceStatusMap[scope.row.status].name"
              :type="UsedDeviceStatusMap[scope.row.status].type"
            >
            </status-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150px"
          ><template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              v-permission="Auth.usedDeviceUpdate"
              plain
              v-if="scope.row.status != 100"
              @click="startUsedDevice(scope.row, scope.$index)"
              >编辑</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="startDetailViewer(scope.$index)"
              >查看</el-button
            >
          </template></el-table-column
        ></el-table
      >
      <ul v-else class="list-style" v-loading="loading">
        <li v-for="(item, index) in devices">
          <div>{{ item.material_desc }}</div>
          <div class="font-12" v-if="item.remark.length > 0">
            备注：<span class="text-danger">{{ item.remark }}</span>
          </div>
          <div class="font-12">序列号：{{ item.serial_number }}</div>
          <div class="font-12 flex-row-between">
            <span>件号：{{ item.material }}</span>
            <span>
              生产年份：{{
                item.product_date.length > 0 ? item.product_date : 'NA'
              }}</span
            >
          </div>
          <div class="flex-row-between font-12">
            <span> 数量：{{ item.quantity }}</span>
            <span>单价：￥{{ item.price }}</span>
          </div>
          <div class="flex-row-between font-12 mt-10">
            <el-button
              type="primary"
              size="mini"
              v-if="item.status != 100"
              v-permission="Auth.usedDeviceUpdate"
              plain
              @click="startUsedDevice(item, index)"
              >编辑</el-button
            >

            <el-button
              type="primary"
              v-if="auth.isPlatformUser()"
              size="mini"
              @click="startDetailViewer(index)"
              >查看/操作
            </el-button>
            <el-button
              v-else
              type="primary"
              size="mini"
              @click="startDetailViewer(index)"
              >查看详情
            </el-button>
          </div>
        </li>
      </ul>
      <div class="mt-20">
        <el-pagination
          class="mt-20"
          :page-size="filter.size"
          :current-page.sync="filter.page"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <used-device-former
      :model="formerModel"
      :show.sync="formerVisible"
      @created="createdUsedDevice"
      @updated="updatedUsedDevice"
    ></used-device-former>
    <detail-viewer
      :model="detailModel"
      :show.sync="detailVisible"
      @sold="soldHandle"
    ></detail-viewer>
  </div>
</template>

<script>
import UsedDeviceFormer from './former'
import DetailViewer from './detail'
import { isMobile, formatTime, clone } from '@/util/index'
import { updateUsedDevice, usedDeviceList } from '../../service/getData'
import auth from '../../util/auth'
import { UsedDeviceStatusMap } from '../../config/global'
import {
  urlPerfix,
  host,
  thumbnailImagePath,
  originImagePath,
} from '@/config/env'

export default {
  name: 'used_device_list',
  components: { UsedDeviceFormer, DetailViewer },
  props: {
    status: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isMobile,
      thumbnailImagePath,
      originImagePath,
      devices: [],
      auth,
      detailModel: null,
      detailIndex: -1,
      detailVisible: false,
      formatTime,
      loading: false,
      formerVisible: false,
      formerModel: {},
      submiting: false,
      UsedDeviceStatusMap,
      editIndex: -1,
      total: 0,
      filter: {
        query: '',
        page: 1,
        status: null,
        not_status: null,
        size: 20,
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.requestDeviceList()
    },
  },
  computed: {
    realFilter() {
      let filter = clone(this.filter)
      if (this.status > 0) {
        filter.status = this.status
      }
      if (this.status < 0) {
        filter.not_status = Math.abs(this.status)
      }
      return filter
    },
  },
  created() {
    this.filter = {
      query: this.$route.query.query || '',
      status: parseInt(this.$route.query.status) || null,
      page: parseInt(this.$route.query.page || 1),
      size: parseInt(this.$route.query.size || 20),
    }
    this.requestDeviceList()
  },
  methods: {
    async requestDeviceList() {
      this.$router.replace({
        query: this.filter,
      })

      this.loading = true
      let data = clone(this.filter)
      data.page = data.page - 1
      data.status = data.status || 0

      if (this.status > 0) {
        data.status = this.status
      }
      if (this.status < 0) {
        data.not_status = Math.abs(this.status)
      }

      if (!auth.isPlatformUser()) {
        data.status = 1
      }
      let res = await usedDeviceList(data)
      if (res.code == 0) {
        this.devices = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    createdUsedDevice(d) {
      this.devices.unshift(d)
    },
    updatedUsedDevice(d) {
      if (this.editIndex >= 0) {
        this.devices.splice(this.editIndex, 1, d)
      }
    },
    importCallback(res) {
      if (res.code == 0) {
        this.reset()
      }
    },
    updateDeviceStatus(index, status) {
      let device = this.devices[index]
      let name = UsedDeviceStatusMap[status].name
      let tips = ''
      if (device.quantity > 1) {
        tips =
          '<p class="text-danger">若设备尚有库存，请直接在编辑设备中修改设备数量</p>'
      }
      this.$confirm('确定变更状态为：' + name + tips, '提示', {
        type: 'warning',
        dangerouslyUseHTMLString: true,
      }).then(() => {
        let that = this
        device.status = status
        this.submiting = true
        updateUsedDevice(device).then((res) => {
          if (res.code == 0) {
            if (status == 100) {
              that.devices.splice(index, 1)
            } else {
              that.devices.splice(index, 1, res.data)
            }
            this.$message.success('操作成功！')
          }
          that.submiting = false
        })
      })
    },
    reset() {
      this.filter = {
        query: '',
        page: 1,
        size: 20,
        status: null,
      }
      this.requestDeviceList()
    },
    startDetailViewer(index) {
      this.detailModel = this.devices[index]
      this.detailIndex = index
      this.detailVisible = true
    },
    soldHandle() {
      this.devices.splice(this.detailIndex, 1)
    },
    startUsedDevice(model, index) {
      if (model.id > 0) {
        this.editIndex = index
        this.formerModel = clone(model)
        this.formerModel.pics = this.formerModel.pics || []
        this.formerModel.report_files = this.formerModel.report_files || []
      } else {
        this.formerModel = {
          material: '',
          material_desc: '',
          quantity: 1,
          serial_number: '',
          remark: '',
          price: 0,
          pics: [],
          report_files: [],
          product_date: null,
        }
      }

      this.formerVisible = true
    },
  },
}
</script>

<style scoped>
.func-btns {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.func-btns .el-button {
  margin: 3px;
}
</style>